<template>
  <!-- 产品详情 -->
  <div class="productSearchContent">
    <!-- 头部 -->
    <!-- <headerNav activeIndex="newsCenter" @setBanner="setBanner"></headerNav> -->
    <div
      class="mobile"
      style="font-size: 0.16rem;min-height:100vh;"
      :style="
        intShow === false || historyShow === true ? '' : 'background:#F5F5F5;'
      "
    >
      <div style="padding:10px 10px 16px;" :style="(intShow === false || historyShow === true)?'background:#44c48d4d;':'background:#f5f5f5;'">
        <div
        style="
          display: flex;
          align-items: center;
          border: 1px solid #e5e5e5;
          border-radius: 50px;
          padding: 0 0.16rem;
          background: #fff;
        "
      >
        <i class="el-icon-search" style="font-size:20px;"></i>
        <el-input
          placeholder="请输入关键字"
          style="width: 100%; border-radius: 50px"
          v-model="searchValue"
          ref="searchValue"
          @focus="historyShow = true"
          @blur="hideHistory"
        >
        </el-input>
        <el-button
          size="mini"
          style="
             background: linear-gradient(45deg, #7ace63 0%, #44c48d 100%);
            color: #fff;
            border-radius: 50px;
            padding: 0 0.2rem;
            height: 0.38rem;
            font-size: 0.16rem;
          "
          @click="searchBtn"
          >搜索</el-button
        >
      </div>
      </div>
      <div
        style="padding: 0.2rem 0.16rem 0; background: #fff;border-radius:8px 8px 0 0;margin-top:-6px;"
        v-if="intShow === false || historyShow === true"
      >
        <div
          v-if="historyList.length > 0"
          style="font-size: 0.2rem; display: flex"
        >
          <div style="flex: 1;font-size:16px;margin-bottom:5px;">搜索历史</div>
          <i class="el-icon-delete" @click="resetHistory"></i>
        </div>
        <div style="display: flex; flex-wrap: wrap">
          <template v-if="historyList.length > 0">
            <div
              v-for="(item, index) of historyList"
              :key="index"
              style="
                padding: 0.05rem 0.16rem;
                margin: 0.1rem 0.02rem;
                background: #f8f8f8;
                border-radius: 20px;
                max-width: 100%;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
              "
              @click="selectHis(item)"
            >
              {{ item }}
            </div>
          </template>
        </div>
        <div style="margin-top:0.2rem;font-size: 0.2rem; display: flex">
          <div style="flex: 1;font-size:16px;margin-bottom:5px;">热门搜索</div>
        </div>
        <div style="display: flex; flex-wrap: wrap">
          <template v-if="hotList.length > 0">
            <div
              v-for="(item, index) of hotList"
              :key="index"
              style="
                padding: 0.05rem 0.16rem;
                margin: 0.1rem 0.02rem;
                background: #f8f8f8;
                border-radius: 20px;
                max-width: 100%;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
              "
              @click="selectHis(item)"
            >
              {{ item }}
            </div>
          </template>
        </div>
      </div>
      <div
        v-else
        style="
          display:inline-block;
          width:calc(100% - 0.4rem);
          margin: -6px 0.1rem 10px;
          padding: 0.2rem 0.1rem 0.15rem;
          border-radius: 4px;
          background: #fff;
          border-radius: 10px;
        "
      >
        <div v-if="newsList.length === 0">
          <van-empty description="暂无信息" />
        </div>
        <div v-else v-loading="loading">
          <div
            style="
              text-align: center;
              font-size: 0.26rem;
              margin-bottom: 0.2rem;
            "
          >
            搜索结果
          </div>
          <div style="position: relative;">
            <img
              src="@/assets/mobile/ye.png"
              style="width: 0.16rem; position: absolute; top: -0.15rem"
              alt=""
            />
            <div
              style="
                width: 99%;
                margin-left: 1%;
                height: 1px;
                background: #3f6b33;
              "
            ></div>
          </div>
          <div>
            <div
            v-for="(item, index) of newsList"
            :key="index"
            style="
              display: flex;
              border-bottom: 1px solid #dddddd;
              padding: 0.16rem 0px;
              margin: 0px 0.1rem;
            "
            @click="goPhoneNews(item.id)"
          >
            <div style="width: 1rem;overflow: hidden;">
              <img
                :src="item.images"
                style="width: 100%; transform: scale(1.5) translateY(17px)"
                alt=""
              />
            </div>
            <div style="flex: 1; margin-right: 0.2rem">
              <div
                style="
                  font-size: 0.17rem;
                  height:0.5rem;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                "
                v-html="item.name"
              ></div>
              <div
                style="
                margin-top:6px;
                  font-size: 0.15rem;
                  display: -webkit-box;
                  -webkit-line-clamp: 4;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                "
                v-html="item.description"
              ></div>
            </div>
            <div
              style="color: #999999; font-size: 0.17rem; margin-top: 0.02rem"
            >
              {{ item.releaseTime }}
            </div>
          </div>
          </div>
          
          <div style="text-align: center; margin: 0.2rem 0 0; color: #666">
            下拉到底部了
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <!-- <RightBar></RightBar> -->
    <!-- <footerNav></footerNav> -->
  </div>
</template>

<script>
import headerNav from "@/components/headerNav/index";
import bannerNav from "@/components/banner/index";
import footerNav from "@/components/footerNav/index";
import {
  getConfByKey,
  updateReadingVolume,
  getProductSearchName,
} from "@/api/common";
import {
  setTokenByName,
  getTokenByName,
  removeTokenByName,
} from "@/utils/auth";
export default {
  name: "productSearch",
  components: { headerNav, footerNav, bannerNav },
  data() {
    return {
      info: {
        carousel: [],
        Mcarousel: "",
      }, //轮播图
      mobile: false,
      newsDetail: {}, //产品详情
      searchValue: "",
      historyList: [],
      intShow: false,
      historyShow: false,
      newsList: [],
      loading: false,
      hotList:["疤痕修复","私密炎症","抗HPV","祛痘控油","舒缓抗敏","紧致抗衰","美白淡斑","痔疮修复"]
    };
  },
  mounted() {
    this.getHistory();
    this.$refs.searchValue.focus()
  },
  methods: {
    setBanner(url, mUrl) {
      this.info = {
        carousel: [url],
        Mcarousel: [mUrl],
      };
    },
    goDetail() {
      findNewsById({ id: this.$route.params.id }).then((response) => {
        this.newsDetail = response.data;
        this.postMessage(
          this.newsDetail.title,
          this.newsDetail.description,
          window.location.href,
          this.getUrlPrefix(this.newsDetail.images)
        );
      });
      updateReadingVolume({ id: this.$route.params.id }).then((response) => {});
    },
    goback() {
      this.$router.back();
    },
    goHome() {
      this.$router.push({ name: "home" });
    },
    // 获取搜索历史
    getHistory() {
      var historyList = getTokenByName("productSearch");
      if (historyList !== undefined && historyList !== null) {
        this.historyList = historyList.split(",");
      }
    },
    resetHistory() {
      removeTokenByName("productSearch");
      this.historyList = [];
    },
    searchBtn() {
      if (this.searchValue !== "" && this.searchValue !== null) {
        this.intShow = true;
        if (this.historyList.indexOf(this.searchValue) === -1) {
          this.historyList.splice(0, 0, this.searchValue);
          if (this.historyList.length > 20) {
            this.historyList.splice(20, 1);
          }
        } else {
          var index = this.historyList.indexOf(this.searchValue);
          this.historyList.splice(index, 1);
          this.historyList.splice(0, 0, this.searchValue);
        }
        setTokenByName("productSearch", this.historyList.join(","));
        var form = {
          searchName: this.searchValue,
        };
        getProductSearchName(form).then((res) => {
          this.loading = false;
          if (res.data.length !== 0) {
            res.data.forEach((item) => {
              var reg = this.searchValue;
              item.name = item.name.replace(
                reg,
                `<b style='color:red;'>${reg}</b>`
              );
              item.images = this.getUrlPrefix(item.images);
            });
          }
          this.newsList = res.data;
        });
      }
    },
    selectHis(name) {
      this.searchValue = name;
      this.searchBtn();
    },

    goPhoneNews(id) {
      this.$router.push({ name: "productCenterDetail", params: { id: id } });
    },

    hideHistory() {
      var that = this;
      setTimeout(() => {
        that.historyShow = false;
      }, 100);
    },
  },
};
</script>

<style lang="scss">
.productSearchContent {
  padding-bottom: calc(env(safe-area-inset-bottom) + 10px) !important;
  min-height:calc(100vh - env(safe-area-inset-bottom) - 10px);
  height:calc(100vh - env(safe-area-inset-bottom) - 10px);
  .el-input {
    .el-input__inner {
      border: 0;
      background: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/productSearch/index.vue